import SectionHeading from '@/components/base/SectionHeading';
import { tips } from '@/mocks/home';

const tagStyles: Record<string, string> = {
  效率: 'bg-secondary-100 text-secondary-900',
  辨别: 'bg-accent-100 text-accent-800',
  方法: 'bg-primary-100 text-primary-700',
  管理: 'bg-secondary-100 text-secondary-900',
  心态: 'bg-accent-100 text-accent-800',
  节奏: 'bg-primary-100 text-primary-700',
};

export default function TipsSection() {
  return (
    <section id="tips" className="w-full bg-background-50 py-16 md:py-24">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-8">
        <SectionHeading
          eyebrow="进阶技巧"
          title="掌握这些吃瓜技巧，效率立刻翻倍"
          desc="当你已经跑通一遍四步攻略，下面这些方法能让你的每一次围观都更有质量——更快、更准、更省心。"
        />

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 md:mt-14 lg:grid-cols-3 lg:gap-5">
          {tips.map((tip) => (
            <article
              key={tip.title}
              className="flex flex-col rounded-lg border border-background-200/80 bg-background-100/50 p-5 transition-colors hover:border-primary-300/70 hover:bg-background-100 md:p-6"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-background-50 text-primary-600">
                  <i className={`${tip.icon} text-xl`} aria-hidden="true"></i>
                </span>
                <span
                  className={`rounded-full px-2.5 py-1 font-label text-xs font-medium ${
                    tagStyles[tip.tag] ?? 'bg-background-200 text-foreground-700'
                  }`}
                >
                  {tip.tag}
                </span>
              </div>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950 md:text-lg">{tip.title}</h3>
              <p className="mt-2.5 text-sm leading-relaxed text-foreground-600">{tip.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}